import { resources as coreResources } from '@diana/core/build/config/i18n/resources';
import { resources } from './i18n';

coreResources.en['components/CalendarDatePicker'].buttons.currentSession = 'Live Session';
export const fullResources = { ...coreResources, ...resources };

declare module '@diana/core' {
  type Resources = typeof fullResources.en;
  interface I18nFeatureResources extends Resources {}
}

export * from './i18n';
